import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './userStudio.css';

const UserStudio = () => {
  const location = useLocation();
  
  return (
    <div className="studio-meta-container">
      {/* Top Navigation Bar */}
      <div className="studio-top-nav-bar">
        <h1 className="studio-top-nav-title">Creator Studio</h1>
        <Link
          to="/bumper"
          className={`studio-nav-item ${location.pathname.includes('/bumper') ? 'active' : ''}`}
        >
          YouTube Upload
        </Link>
      </div>
    </div>
  );
};

export default UserStudio;
